const config = {
    publicPath: process.env.NODE_ENV === 'production'
        ? ''
        : '/myapi',
}

export default config